<template>
  <div id="404">
    <section>
      <v-parallax src="/img/mountains.jpg" height="470" style="padding: 0;">
        <v-layout id="hero" column align-center justify-center px-12>
          <h0 class="mb-2 text-center">404</h0>
          <div class="subheading mb-4 text-center">
            {{ $t("page_not_found") }}
          </div>
        </v-layout>
      </v-parallax>
    </section>
  </div>
</template>

<script>
export default {
  head: function() {
    return {
      title: {
        inner: this.$i18n.t(name),
        separator: "—",
        complement: this.$i18n.t("extrapost")
      },
      meta: [
        {
          name: "prerender-status-code",
          content: "404",
          id: "prerender-status-code"
        }
      ]
    };
  }
};
</script>
